var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 18C24 14.6863 26.6863 12 30 12C33.3137 12 36 14.6863 36 18C36 21.3137 33.3137 24 30 24C26.6863 24 24 21.3137 24 18ZM30 16C28.8954 16 28 16.8954 28 18C28 19.1046 28.8954 20 30 20C31.1046 20 32 19.1046 32 18C32 16.8954 31.1046 16 30 16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4H43.9997V44H4V4ZM8 8V26.0553L17.8508 18.8379L18.787 21.2855C20.5135 25.7997 24.8854 29 29.9997 29C34.1708 29 37.8469 26.873 39.9997 23.636V8H8ZM39.9997 29.4903C37.2615 31.6853 33.7845 33 29.9997 33C24.0894 33 18.9311 29.796 16.1609 25.0347L8 31.014V40H39.9997V29.4903Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageSquare);
export default __webpack_public_path__ + "static/media/image-square.eefc4be6b4de68d2059197838716ca5f.svg";
export { ForwardRef as ReactComponent };